import { render, staticRenderFns } from "./security_shift_history.vue?vue&type=template&id=5b43de43"
import script from "./security_shift_history.vue?vue&type=script&lang=js"
export * from "./security_shift_history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports